import {
  Editor,
  Node,
  Range,
  Transforms,
  Path
} from 'slate';
import {
  ReactEditor
} from 'slate-react';

import isUrl from 'is-url';

import types from '../../elements/types';

import HelptapEditor from '../../helpers';

export default function withParagraph(editor) {
  const { insertBreak, deleteBackward, normalizeNode } = editor;

  editor.insertBreak = () => {
    const { selection } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [match] = Editor.nodes(editor, {
        match(node) {
          return node.type === types.DEFAULT;
        },
        mode: 'lowest',
      });

      if (match) {
        const [node, path] = match;
        const text = Node.string(node);

        if (text === '') {
          HelptapEditor.paragraph.insert(editor, Path.next(path));
          return;
        }

        if (isUrl(text)) {
          if (!editor.disabledElements.includes(types.URL_EMBED)) {
            HelptapEditor.paragraph.convertToURLEmbed(editor, path, node, text);
            const newParagraph = {
              type: types.DEFAULT,
              children: [{ text: '' }],
            };
            Transforms.insertNodes(editor, newParagraph, { at: Editor.after(editor, path) });
            Transforms.select(editor, Editor.after(editor, path));
            return;
          }
        }
      }
    }

    insertBreak();
  };

  editor.deleteBackward = (unit) => {
    const [match] = Editor.nodes(editor, {
      match(node) {
        return node.type === types.DEFAULT;
      },
      mode: 'lowest',
    });

    if (match) {
      const [node, path] = match;

      if (Node.string(node).trim() === '' && HelptapEditor.layout.removeEmptyBlock(editor, path) === true) {
        return;
      }

      if (Node.string(node).trim() === '') {
        Editor.withoutNormalizing(editor, () => {
          Transforms.removeNodes(editor, { at: path });
          if (Path.hasPrevious(path) === true) {
            const previousPath = Path.previous(path);
            const previousNode = Node.get(editor, previousPath);
            if (previousNode.type === types.TOGGLE_LIST_ITEM) {
              Transforms.select(editor, Editor.end(editor, [...previousPath, 0]));
            } else {
              Transforms.select(editor, Editor.end(editor, Path.previous(path)));
            }
          } else {
            const parentPath = Path.parent(path);
            const parent = Node.get(editor, parentPath);
            if (parent.type === types.TOGGLE_LIST_BODY && path[path.length - 1] === 0) {
              Transforms.select(editor, Editor.end(editor, [...Path.parent(parentPath), 0]));
            }
          }
          ReactEditor.focus(editor);
        });
        return;
      }
    }

    deleteBackward(unit);
  };

  editor.normalizeNode = ([node, path]) => {
    if (node.type === types.DEFAULT) {

      if (Array.isArray(node.children) === false) {
        Transforms.removeNodes(editor, { at: path });
        return;
      } else if (node.children.length === 0) {
        Transforms.insertNodes(
          editor, { text: '' }, { at: [...path, 0] }
        );
        return;
      }

    }

    normalizeNode([node, path]);
  };

  return editor;
}